module.exports = __webpack_public_path__ + "static/img/Bachelor_010715.ad4dfb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010715.jpg
// module id = 231
// module chunks = 0